import { useThemeStore } from "@stores/theme.store";
import moment from "moment-timezone";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
moment.locale("id");
export const AchievementDetailPage = () => {
  const { state } = useLocation();
  const { setHeader, setAppBar } = useThemeStore((state) => state);

  useEffect(() => {
    setAppBar({ title: "Detail Prestasi", show: true, leading: "back" });
    setHeader({
      buttonBack: true,
      filter: false,
      title: "Detail Prestasi",
      image: false,
    });
  }, [setHeader, setAppBar]);

  return (
    <>
      <div className="tw-px-4 tw-pt-2 tw-pb-20">
        <div className=" tw-rounded-lg card-body">
          <div className="tw-text-accent-primary tw-text-xs">Tanggal</div>
          <div className="tw-mb-4 tw-text-text-primary tw-font-semibold">
            {moment(state.tanggal ?? Date.now()).format("dddd, DD MMMM YYYY")}
          </div>
          <div className="tw-text-accent-primary tw-text-xs">Prestasi</div>
          <div className="tw-mb-4 tw-text-text-primary tw-font-semibold">
            {state.prestasi ?? "-"}
          </div>

          <div className="tw-text-accent-primary tw-text-xs">Reward</div>
          <div className="tw-mb-4 tw-text-text-primary tw-font-semibold">
            {state.reward ?? "-"}
          </div>

          <div className="tw-text-accent-primary tw-text-xs">Poin</div>
          <div className="tw-mb-4 tw-text-text-primary tw-font-semibold">
            {state.poin ?? "-"}
          </div>

          <div className="tw-text-accent-primary tw-text-xs">Catatan</div>
          <div className="tw-mb-4 tw-text-text-primary tw-font-semibold">
            {state.catatan ?? "-"}
          </div>
        </div>
      </div>
    </>
  );
};
